import React from 'react';
import { fmt } from './posV2Utils';

const Kpi = ({ label, value, accent }) => (
  <div className="px-3 py-1.5 rounded-lg bg-black/30 border border-white/10 min-w-[72px]">
    <div className="text-[10px] text-gray-500 uppercase tracking-wide">{label}</div>
    <div className={`text-sm font-bold ${accent || 'text-gray-200'}`}>{value}</div>
  </div>
);

const PosV2CaisseFooter = ({ dashboard, sessionMag }) => {
  if (!dashboard) return null;
  return (
    <footer className="fixed bottom-0 left-0 right-0 z-40 border-t border-white/10 bg-[#0a0c10]/95 backdrop-blur-md">
      <div className="max-w-[1600px] mx-auto px-3 py-2 flex flex-wrap items-center gap-2 overflow-x-auto text-gray-300">
        <span className="text-xs font-bold text-red-400 mr-1 shrink-0">Activité {sessionMag}</span>
        <Kpi label="CA jour" value={`${fmt(dashboard.ca_jour)} €`} accent="text-red-400" />
        <Kpi label="Ventes" value={dashboard.nb_ventes} />
        <Kpi label="Répar." value={dashboard.nb_reparations} />
        <Kpi label="Cmd." value={dashboard.nb_commandes} />
        <Kpi label="Panier moy." value={`${fmt(dashboard.panier_moyen)} €`} />
        <Kpi label="Espèces" value={`${fmt(dashboard.total_especes)} €`} />
        <Kpi label="SumUp" value={`${fmt(dashboard.total_sumup)} €`} />
        <span className="text-[10px] text-gray-500 ml-auto shrink-0">
          {dashboard.is_open
            ? `${dashboard.vendeur || '—'} · depuis ${dashboard.caisse_ouverte_depuis || '—'} · ${dashboard.sync_status}`
            : 'Caisse fermée'}
        </span>
      </div>
    </footer>
  );
};

export default PosV2CaisseFooter;
